import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets: string[] = [
    'stickyFooterFeed',
    'stickyFooterFeedCloseBtn',
    'stickyFooterFeedHoverLink'
  ];
  static requiredTargets = [];
  declare stickyFooterFeedTarget: HTMLDivElement;
  declare stickyFooterFeedCloseBtnTarget: HTMLDivElement;
  declare stickyFooterFeedHoverLinkTarget: HTMLDivElement;

  connect() {
    this.stickyFooterFeedHoverLinkTarget.addEventListener('mouseenter', this.hoverIn.bind(this));
  }

  hoverIn() {
    this.stickyFooterFeedTarget.classList.add('feed-open');
    this.stickyFooterFeedTarget.addEventListener('mouseleave', this.hoverOut.bind(this));
  }

  hoverOut() {
    this.stickyFooterFeedTarget.removeEventListener('mouseleave', this.hoverOut.bind(this));
    this.closeFeed();
  }

  closeFeed() {
    this.stickyFooterFeedTarget.classList.remove('feed-open');
  }

  showLoyaltyModal() {
    window.dispatchEvent(new CustomEvent('show-loyalty-modal'));
  }
}
